<template>
  <div>
    <div class='spe-door-card-modal'
         v-if='speDoorCardModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>
          {{ $t('jj_door_card_info') }}
        </div>
        <div class='door-card-info'>
          <div class='info-item'>
            <div class='info-item-label'>
              {{ $t('jj_room_no') }}：
            </div>
            <div class='info-item-content'>{{ ResponseParameters.roomNo }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>
              {{ $t('jj_beginTime') }}：
            </div>
            <div class='info-item-content'>{{ ResponseParameters.beginTime }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>
              {{ $t('jj_endTime') }}：
            </div>
            <div class='info-item-content'>{{ ResponseParameters.endTime }}</div>
          </div>
        </div>

        <div class='spe-door-card-bottom'
             @click='speDoorCardModalShow = false'>
          {{ $t('determine') }}
        </div>
      </div>
    </div>
    <div class='spe-jingJiangModal'>
      <mt-popup v-model="speJingJiangModalShow"
                class='guestInfo-jingJiangModal'
                popup-transition="popup-fade">
        <div class='jingJiangModal-main'>
          <h2>{{ $t('jj_doorCard_operate') }} ({{ $t('jj_room_no') }}:{{ masterBase.rmno }})</h2>
          <div class='modal-container'>
            <div class='spe-row'>
              <div class='btn-default'
                   @click='getJingJiangToken("addCard")'>{{ $t('jj_addCard') }}
              </div>
              <div class='btn-default'
                   @click='getJingJiangToken("copyCard")'>{{ $t('jj_copyCard') }}
              </div>
            </div>
            <div class='spe-row'>
              <div class='btn-default'
                   @click='getJingJiangToken("readCard")'>{{ $t('jj_readCard') }}
              </div>
              <div class='btn-default'
                   @click='getJingJiangToken("cancelCard")'>{{ $t('jj_cancelCard') }}
              </div>
            </div>
          </div>

          <div class="btn">
            <div class="unSure"
                 @click="speJingJiangModalShow=false">{{ $t('cancel') }}
            </div>
            <div class="sure"
                 @click="save">{{ $t('determine') }}
            </div>
          </div>
        </div>
      </mt-popup>

    </div>
  </div>
</template>
<script>
import moment from 'moment'
import {
  Toast, MessageBox
} from 'mint-ui';

export default {
  data() {
    return {
      lockNumber: '',

      speJingJiangModalShow: false,
      days: 1,
      masterBase: {},
      jingJiangToken: '',
      configObj: {
        'Category': 1,
        'CardType': 'GuestCard',
      },
      chainNo: '',
      Key: '',

      ResponseParameters: {
        roomNo: '',
        beginTime: '',
        endTime: '',
      },
      speDoorCardModalShow: false,
    };
  },
  props: {},
  mounted() {
  },
  methods: {
    show(obj) {
      this.speJingJiangModalShow = true;
      this.masterBase = obj || {}
    },

    formatJingJiangDate(date) {
      return moment(new Date(date)).format('YYYY-MM-DD HH:mm')
    },

    addCard() {
      const masterBase = this.masterBase
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Add',
        'CardType': this.configObj.CardType,
        'Parameters': {
          'roomNo': masterBase.rmno,
          'beginTime': this.formatJingJiangDate(masterBase.arr),
          'endTime': this.formatJingJiangDate(masterBase.dep),
          'chainNo': this.chainNo || '',
          'lockNumber': this.lockNumber
        }
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        // alert(JSON.stringify(res,null,4))
        if (res.data.result == 0) {
          this.msg2(this.$t('jj_addCard_success'))
        } else {
          MessageBox.alert(res.data.msg)
        }
      });

    },

    copyCard() {
      const masterBase = this.masterBase
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Copy',
        'CardType': this.configObj.CardType,
        'Parameters': {
          'roomNo': masterBase.rmno,
          'beginTime': this.formatJingJiangDate(masterBase.arr),
          'endTime': this.formatJingJiangDate(masterBase.dep),
          'chainNo': this.chainNo || '',
          'lockNumber': this.lockNumber
        }
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        // alert(JSON.stringify(res,null,4))
        if (res.data.result == 0) {
          this.msg2(this.$t('jj_copyCard_success'))
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    readCard() {
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Read',
        'CardType': this.configObj.CardType,
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        if (res.data.result == 0) {
          this.msg2(this.$t('jj_readCard_success'))
          let retVal = res.data.retVal || {}
          this.ResponseParameters = retVal.ResponseParameters || {}
          this.speJingJiangModalShow = false
          this.speDoorCardModalShow = true
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    cancelCard() {
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Cancel',
        'CardType': this.configObj.CardType,
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        // alert(JSON.stringify(res,null,4))
        if (res.data.result == 0) {
          this.msg2(this.$t('jj_cancelCard_success'))
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    getJingJiangToken(action) {
      let objStr = localStorage.getItem('JingJiangSetting') || '{}'
      let obj = JSON.parse(objStr)
      this.chainNo = obj.HotelId || ''
      this.Key = obj.Key || ''
      obj.isJingJiangLocal = true
      // this.$http.post('/mobilepmsapi/pos/getJingJangToken', obj).then(res => {
      this.$http.post('/CardService/Authorize', obj).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {}
          this.jingJiangToken = retVal.Token || '';

          if (action == 'addCard') {
            this.addCard()
          } else if (action == 'readCard') {
            this.readCard()
          } else if (action == 'copyCard') {
            this.copyCard()
          } else if (action == 'cancelCard') {
            this.cancelCard()
          }

        } else {
          MessageBox.confirm(this.$t('jj_token_error'))
            .then(action => {
              if (action == 'confirm') {
                this.$router.push('/testjingjiang')
              }
            })
            .catch(action => {
            });
        }
      });
    },

    save() {
      const self = this
      this.speJingJiangModalShow = false;
      setTimeout(() => {
        self.masterBase = {}
      }, 100)
    },

    goSetting() {
      this.$router.push('/testjingjiang')
    },
  },
  components: {}
};
</script>

<style lang='less'>

.spe-door-card-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1011;

  .door-card-container {
    overflow: hidden;
    position: fixed;
    width: 70%;
    background: #fff;
    z-index: 1112;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;

    .door-card-title {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #eee;
      text-align: center;
    }

    .door-card-info {
      box-sizing: border-box;
      height: 140px;

      .info-item {
        padding: 10px 15px;
        display: flex;

        .info-item-label {
          color: #333;
          width: 80px;
        }

        .info-item-content {
          color: #666;
        }
      }
    }

    .spe-door-card-bottom {
      height: 45px;
      line-height: 45px;
      border-top: 1px solid #eee;
      text-align: center;

      &:active {
        background: #eee;
      }
    }
  }
}

.spe-jingJiangModal {

  .guestInfo-jingJiangModal {
    width: 100%;
    height: 300px;
    position: absolute;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    background: none;

    .jingJiangModal-main {
      background: #fff;
      width: 80%;
      margin: 0 auto;
      box-sizing: border-box;
      border-radius: 10px;
    }

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 15px 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .modal-container {
      padding: 15px;

      .spe-row {
        display: flex;
        justify-content: space-between;

        .btn-default {
          display: inline-block;
          border: 1px solid #ddd;
          text-align: center;
          font-size: 14px;
          border-radius: 4px;
          padding: 10px 0;
          box-sizing: border-box;
          width: 45%;
          margin-bottom: 15px;

          &:active {
            background: #eee;
          }
        }
      }
    }

    .setting-row {
      padding: 15px;
      text-align: right;

      .iconfont {
        color: #666;
      }
    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      width: 100%;

      .unSure {
        border-right: 1px solid #bdbdbd;
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
      }

      .sure {
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// jingJiangModal.vue?e2581d6c